module.exports = __webpack_public_path__ + "static/img/p-image-1.ee244ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_pc/p-image-1.png
// module id = EcM8
// module chunks = 0